/**
 * REASONS for update 2
 *
 * Add new table for map hosts. Don't forget to update
 * settings store with the new pagination param and value
 *
 * Implement a delete/recreate action to add/refresh settings DB
 *
 * Add table crash
 * Used to save an ongoing recording in case the page is reloaded
 * unintentionally...
 */

import initialMapHostsData from '../data/initialMapHostsData'
import updateOneSettingsAfterUpdate from './updateOneSettingsAfterUpdate'

/* eslint-disable no-console */

const checkIfUpdateIsNeededForVersion2 = async (e, version) => {
  console.groupCollapsed('CHECK IF UPDATE IS NEEDED FOR v16')
  console.log('> Add new store "MapHosts" Remove store "apikeys", if it exists.')

  // Set the db variable to our database so we can use it!
  const db = e.target.result

  if (db.objectStoreNames.contains('mapHosts')) {
    db.deleteObjectStore('mapHosts')
    console.log('Deleted object store mapHosts')
  }

  /**
   * ----- Create ObjectStore "MapHosts"
   */
  if (!db.objectStoreNames.contains('mapHosts')) {
    // Create an object store named notes. Object stores
    // in databases are where data are stored.
    const mapHostsStore = db.createObjectStore('mapHosts', { autoIncrement: true })

    // Create indexes
    mapHostsStore.createIndex('title', 'title', { unique: true })
    mapHostsStore.createIndex('type', 'type', { unique: false })

    // Prepare database transaction
    const txn = e.target.transaction

    // Add initial data by getting the current transaction
    initialMapHostsData.forEach(host => {
      const addRequest = txn.objectStore('mapHosts').add(host)
    })

    console.info('onupgradeneeded: store "mapHosts" created and initial content added')

    // Add a new pagiantion value to the "settings" object store
    const updateSettingsObj = {
      feature: 'maxMapHostsPerPage',
      value: 10
    }

    const updateSettings = await updateOneSettingsAfterUpdate(txn, updateSettingsObj, version)
    const success = await updateSettings
  }
  else {
    console.info('onupgradeneeded: store "mapHosts" already exists')
  }

  // In case "apikeys" exists, delete it
  // if (db.objectStoreNames.contains('apikeys')) {
  //   db.deleteObjectStore('apikeys')
  //   console.info('onupgradeneeded: store "apikeys" deleted')
  // }
  // else {
  //   console.warn('The store "apikeys" does not exists (anymore). It was probably removed in an earlier version or never installed due to changes in the development process.')
  // }

  /**
   * ----- ObjectStore "Crash"
   */
  if (!db.objectStoreNames.contains('crash')) {
    // Create object store
    const crashStore = db.createObjectStore('crash', { autoIncrement: true, keyPath: 'id' })

    console.info('onupgradeneeded: store "crash" created')
  }
  else {
    console.info('onupgradeneeded: store "crash" already exists')
  }

  console.groupEnd()
}

export default checkIfUpdateIsNeededForVersion2
